import classNames from 'classnames';
import type { ReactElement, Ref, RefObject } from 'react';
import { useRef } from 'react';
import { useScrollTransition } from 'util/react-transition-component';
import styles from './ScrollTransition.module.scss';
import { setupTransitionInTimeline } from './ScrollTransition.transitions';
import type { ScrollTransitionProps, ScrollTransitionRef } from './ScrollTransition.data';

function ScrollTransition({
  as = 'div',
  children,
  type,
  trigger,
  disableTriggerInOnScroll = false,
  vars,
  config,
  ref,
  ...props
}: ScrollTransitionProps & { ref?: Ref<ScrollTransitionRef> }): ReactElement {
  const localRef = useRef(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const elementRef = (ref || localRef) as RefObject<any>;

  useScrollTransition({
    scroll: {
      trigger: trigger || elementRef,
      disableTriggerInOnScroll,
      vars: {
        scrub: true,
        ...vars,
      },
    },
    setupOptions: () => ({
      refs: {
        elementRef,
        type,
        config,
        disableTriggerInOnScroll,
      },
      setupTransitionInTimeline,
    }),
  });

  const Tag = as;

  return (
    <Tag ref={elementRef} className={classNames(styles.scrollParallax, props.className)}>
      {children}
    </Tag>
  );
}
ScrollTransition.displayName = 'ScrollTransition';

export default ScrollTransition;
